export default "__VITE_ASSET__CrKds63L__"